import React from "react";
import PropTypes from 'prop-types';

export default class DropDown extends React.Component {
    change = ({target: { value }}) => {
        const {onChange} = this.props;

        onChange(value);
    }

    render() {
        const {name, className, options, defaultValue, onChange} = this.props;

        return <select className={`${className}`} name={name} value={defaultValue ? defaultValue : ''} onChange={this.change}>
            {options && options.map(option => <option value={option.value ? option.value : ''} dangerouslySetInnerHTML={{__html: option.label}}></option>)}
        </select>;
    }
}

DropDown.propTypes = {
    name: PropTypes.string,
    options: PropTypes.array.isRequired,
    className: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func
}

DropDown.defaultProps = {
    name: '',
    options: [],
    className: '',
    defaultValue: null,
    onChange: () => {}
}